module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"pagination":"pagination"},"en":{"pagination":"pagination"},"de":{"pagination":"paginierung"},"es":{"pagination":"paginación"},"it":{"pagination":"paginatura"},"nl":{"pagination":"paginering"},"pt":{"pagination":"paginação"}}')
  delete Component.options._Ctor
}
